import React from 'react';
import cx from 'classnames';
import { cellPhone } from '../../../utils/mask';
import styles from '../CallNow.module.css';
import { CallToNowButton } from './CallToNowButton';
import { SeeNumber } from './SeeNumber';

interface Props {
  numberPhone: string;
  hasToCall: boolean;
  seeNumber: boolean;
  type: 'big' | 'small';
  dataValue?: string | any;
  dataValueClassName?: string;
  contacts?: { infoContact: string }[];
  adId: number;
}

export const renderRevealNameWithCallButton = ({
  numberPhone,
  hasToCall,
  seeNumber,
  type,
  dataValue,
  dataValueClassName,
  contacts,
  adId,
}: Props) => {
  const nameAndCallBtn = cx(
    'flex flex-column items-start overflow-hidden',
    dataValueClassName,
    styles.linearTransition,
    {
      [styles.initialNameAndCallBtn]: !seeNumber,
      [styles.finnalyNameAndCallBtn]: seeNumber,
      'o-0': !seeNumber,
      'o-100': seeNumber,
    },
  );

  const numberClass = cx(
    'white fw3 ma0 tl',
    dataValueClassName,
    {
      'f14 f16-l': type === 'small',
      f24: type === 'big',
    },
    'truncate',
  );

  const wattsMessage = `Olá, vi um anúncio no site Autoscar.com.br e gostaria de mais informações! ${
    typeof window !== 'undefined' ? window.location.href : ''
  }`;

  const renderContact = (secondaryPhone: string) => {
    if (secondaryPhone) {
      const formattedNumber = cellPhone(
        secondaryPhone[0] === '0' ? secondaryPhone.substring(1) : secondaryPhone,
      );

      return (
        <>
          <p data-value={dataValue} className={numberClass}>
            {formattedNumber}
          </p>
          <CallToNowButton
            text={wattsMessage}
            numberPhone={secondaryPhone}
            hasToCall={hasToCall}
            type={type}
            dataValue={dataValue}
            dataValueClassName={dataValueClassName}
            adId={adId}
          />
        </>
      );
    }

    return null;
  };

  const handleMapContacts = (contact: { infoContact: string }) =>
    renderContact(contact.infoContact);

  const fetchContacts = () => {
    if (hasToCall) {
      return <>{contacts?.map(handleMapContacts)}</>;
    }

    return null;
  };

  return (
    <div data-value={dataValue} className={nameAndCallBtn}>
      <CallToNowButton
        text={wattsMessage}
        numberPhone={numberPhone}
        hasToCall={hasToCall}
        type={type}
        dataValue={dataValue}
        dataValueClassName={dataValueClassName}
        adId={adId}
      />

      {fetchContacts()}
    </div>
  );
};

export const PhoneCallNow = ({
  numberPhone,
  hasToCall,
  seeNumber,
  type,
  dataValue,
  dataValueClassName,
  contacts,
  adId,
}: Props) => {
  const formatPhoneNumber = cellPhone(
    numberPhone[0] === '0' ? numberPhone.substring(1) : numberPhone,
  );

  const smallStyle = cx('f14 f16-l w-100', {
    mt8: seeNumber,
    mt0: !seeNumber,
  });
  const styleByType = cx({
    [smallStyle]: type === 'small',
    f24: type === 'big',
  });
  const truncateStyle = cx({
    [styles.smallNumberTruncate]: type === 'small',
    [styles.numberTruncate]: type === 'big',
  });
  const numberTruncate = cx(
    'white fw3 ma0 tl',
    dataValueClassName,
    {
      [truncateStyle]: !seeNumber,
      [styles.numberTrucanteMaxWidth]: seeNumber,
    },
    styles.animation,
    styleByType,
  );

  const renderSeeNumberText = () => {
    return !seeNumber ? (
      <SeeNumber
        hasToCall={hasToCall}
        revealNumber={seeNumber}
        type={type}
        dataValue={dataValue}
        dataValueClassName={dataValueClassName}
      />
    ) : null;
  };

  const numberContainerClass = cx('flex', dataValueClassName, {
    'flex-column-ns flex-row-l items-center items-start-ns items-center-l': type === 'small',
    relative: type === 'big',
  });

  const numberClass = cx(
    'white fw3 ma0 tl',
    dataValueClassName,
    {
      'f14 f16-l': type === 'small',
      f24: type === 'big',
    },
    'truncate',
  );

  const containerClass = cx('flex flex-column items-start', dataValueClassName, {
    ml8: type === 'small',
    ml16: type === 'big',
  });

  return (
    <div data-value={dataValue} className={containerClass}>
      <div data-value={dataValue} className={numberContainerClass}>
        <div data-value={dataValue} className={numberTruncate}>
          <p data-value={dataValue} className={numberClass}>
            {formatPhoneNumber}
          </p>
        </div>
        {renderSeeNumberText()}
      </div>

      {
        // tslint:disable-next-line: jsx-no-multiline-js
        renderRevealNameWithCallButton({
          numberPhone,
          hasToCall,
          seeNumber,
          type,
          dataValue,
          dataValueClassName,
          contacts,
          adId,
        })
      }
    </div>
  );
};
